'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

var _formatMath = require('./formatters/format-math.js');

var _formatMath2 = _interopRequireDefault(_formatMath);

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _greekLetters = require('./tokens/greek-letters');

var greekLetters = _interopRequireWildcard(_greekLetters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Functors
var stripParenthesis = function stripParenthesis(mathString) {
  return mathString.substr(1, mathString.length - 2);
};

/**
 * A class for parsing latex math
 */

var AlgebraLatex = function () {
  /**
   * Create an AlgebraLatex object, to be converted
   * @param  {String} latex The latex to parse
   * @return {AlgebraLatex} object to be converted
   */
  function AlgebraLatex(latex) {
    _classCallCheck(this, AlgebraLatex);

    _logger2.default.debug('Creating AlgebraLatex object with input: ' + latex);
    this.texInput = latex;

    this.structure = (0, _parser2.default)(latex);
  }

  /**
   * Will return a serialized string eg. 2*(3+4)/(sqrt(5))-8
   * @return string The serialized string
   */


  _createClass(AlgebraLatex, [{
    key: 'toMath',
    value: function toMath() {
      if (typeof this.formattedMath === 'undefined') {
        this.formattedMath = stripParenthesis((0, _formatMath2.default)(this.structure));
      }

      return this.formattedMath;
    }

    /**
     * Will return an algebra.js Expression or Equation
     * @param {Object} algebraJS an instance of algebra.js
     * @return {(Expression|Equation)} an Expression or Equation
     */

  }, {
    key: 'toAlgebra',
    value: function toAlgebra(algebraJS) {
      if (algebraJS === null) {
        throw new Error('Algebra.js must be passed as a parameter for toAlgebra');
      }

      var mathToParse = this.toMath();
      mathToParse = greekLetters.convertSymbols(mathToParse);

      return algebraJS.parse(mathToParse);
    }

    /**
     * Will return an algebrite object
     * @param {Object} algebrite an instance of algebrite
     * @return {Object} an algebrite object
     */

  }, {
    key: 'toAlgebrite',
    value: function toAlgebrite(algebrite) {
      if (algebrite === null) {
        return new Error('Algebrite must be passed as a parameter for toAlgebrite');
      }

      if (this.isEquation()) {
        return new Error('Algebrite can not handle equations, only expressions');
      }

      var mathToParse = this.toMath();
      mathToParse = greekLetters.convertSymbols(mathToParse);

      return algebrite.eval(mathToParse);
    }

    /**
     * Will return a coffequate object
     * @return {Object} a coffeequate object
     */

  }, {
    key: 'toCoffeequate',
    value: function toCoffeequate(coffeequate) {
      if (coffeequate === null) {
        return new Error('Coffeequante must be passed as a parameter for toCoffeequante');
      }

      var result = this.toMath();
      result = result.replace('^', '**');

      return coffeequate(result);
    }

    /**
     * Wether or not the object is an equation or an expression
     * @return Boolean true if expression
     */

  }, {
    key: 'isEquation',
    value: function isEquation() {
      return this.texInput.includes('=');
    }
  }]);

  return AlgebraLatex;
}();

module.exports = AlgebraLatex;


// WEBPACK FOOTER //
// ./~/algebra-latex/lib/index.js